<script>
  import MiniLogo from "../Misc/MiniLogo.svelte";
  import ValidationError from "../Misc/ValidationError.svelte";
  import Or from "../Misc/Or.svelte";
  import { createEventDispatcher } from "svelte";
  import { auth, db } from "../firebase";

  const dispatch = createEventDispatcher();
  function login() {
    dispatch("login");
  }

  let email = "",
    firstName = "",
    lastName = "",
    phoneNumber = "",
    password = "",
    confirmPassword = "",
    profession = "buyer",
    nmlsId = "",
    licenseNumber = "";

  let emailValidationError,
    firstNameValidationError,
    lastNameValidationError,
    phoneNumberValidationError,
    passwordValidationError,
    confirmPasswordValidationError,
    nmlsIdValidationError,
    licenseNumberValidationError,
    registerError;

  function register() {
    registerError = null;
    let formValid = registerValidation();
    if (!formValid) {
      return;
    }

    auth
      .createUserWithEmailAndPassword(email, password)
      .then(result => {
        const user = result.user;
        db.collection('users').doc(user.uid)
          .set({
            uid: user.uid,
            email: email,
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            profession: profession,
            nmlsId: nmlsId,
            licenseNumber: licenseNumber,
            created: Date.now()
          })
          .then(function() {

          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
          });
      })
      .catch(function(error) {
        let errorCode = error.code;
        let errorMessage = error.message;
        console.log(errorCode, errorMessage);
        registerError = errorMessage;
      });
  }

  function registerValidation() {
    let isValid = true;
    if (!email) {
      emailValidationError = "Email address required";
      isValid = false;
    }

    if (!password) {
      passwordValidationError = "Password required";
      isValid = false;
    }

    if (!confirmPassword || password != confirmPassword) {
      confirmPasswordValidationError = "Passwords do not match";
      isValid = false;
    }

    if (!firstName) {
      firstNameValidationError = "First name is required";
      isValid = false;
    }

    if (!lastName) {
      lastNameValidationError = "Last name is required";
      isValid = false;
    }

    if(!phoneNumber) {
      phoneNumberValidationError = "Phone number is required";
      isValid = false;
    }

    if (profession === "lo" && !nmlsId) {
      nmlsIdValidationError = "Please provide your NLMS Id";
      isValid = false;
    }

    if (profession === "agent" && !licenseNumber) {
      licenseNumberValidationError = "Please provide your license number";
      isValid = false;
    }

    return isValid;
  }
</script>

<style>
  .form-register {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
</style>

<form class="form-register" on:submit|preventDefault={register}>
  <div class="text-center">
    <MiniLogo />
    <h1 class="h3 mb-3 font-weight-normal">Create your account</h1>
  </div>
  <ValidationError message={registerError} />

  <div class="form-group">
    <label>Email & Password</label>
    <input
      type="email"
      class="form-control text-left"
      id="emailInput"
      aria-describedby="emailHelp"
      placeholder="Enter email"
      bind:value={email}
      on:change={() => (emailValidationError = null)} />
    <ValidationError message={emailValidationError} />
    <input
      type="password"
      class="form-control"
      id="passwordInput"
      placeholder="Password"
      bind:value={password}
      on:change={() => (passwordValidationError = null)} />
    <ValidationError message={passwordValidationError} />
    <input
      type="password"
      class="form-control"
      id="confirmPasswordInput"
      placeholder="Confirm Password"
      bind:value={confirmPassword}
      on:change={() => (confirmPasswordValidationError = null)} />
    <ValidationError message={confirmPasswordValidationError} />
  </div>
  <div class="form-group">
    <label>Contact Info</label>
    <input
      type="text"
      class="form-control"
      id="firstName"
      placeholder="First Name"
      bind:value={firstName}
      on:change={() => (firstNameValidationError = null)} />
    <ValidationError message={firstNameValidationError} />
    <input
      type="text"
      class="form-control"
      id="lastName"
      placeholder="Last Name"
      bind:value={lastName}
      on:change={() => (lastNameValidationError = null)} />
    <ValidationError message={lastNameValidationError} />
    <input
      type="text"
      class="form-control"
      id="phoneNumber"
      placeholder="Phone Number"
      bind:value={phoneNumber}
      on:change={() => (phoneNumberValidationError = null)} />
    <ValidationError message={phoneNumberValidationError} />
  </div>
  <div class="form-group">
    <label>Status</label>
    <br />
    <div class="form-check">
      <input
        bind:group={profession}
        class="form-check-input"
        type="radio"
        name="profession"
        id="inlineCheckbox3"
        value="buyer" />
      <label class="form-check-label" for="inlineCheckbox3">Home Buyer</label>
    </div>
    <div class="form-check">
      <input
        bind:group={profession}
        class="form-check-input"
        type="radio"
        name="profession"
        id="inlineCheckbox1"
        value="lo" />
      <label class="form-check-label" for="inlineCheckbox1">Loan Officer</label>
    </div>
    <div class="form-check">
      <input
        bind:group={profession}
        class="form-check-input"
        type="radio"
        name="profession"
        id="inlineCheckbox2"
        value="agent" />
      <label class="form-check-label" for="inlineCheckbox2">
        Real Estate Agent
      </label>
    </div>
  </div>

  <div class="form-group">
    {#if profession === 'lo'}
      <input
        type="number"
        class="form-control"
        id="nmlsid"
        placeholder="Your NMLS Id"
        bind:value={nmlsId}
        on:change={() => (nmlsIdValidationError = null)} />
      <ValidationError message={nmlsIdValidationError} />
    {:else if profession === 'agent'}
      <input
        type="text"
        class="form-control"
        id="license"
        placeholder="Your license number"
        bind:value={licenseNumber}
        on:change={() => (licenseNumberValidationError = null)} />
      <ValidationError message={licenseNumberValidationError} />
    {/if}
  </div>

  <div style="padding-top:1em;">
    <button
      class="btn btn-lg btn-primary btn-block"
      type="submit">
      Create
    </button>
  </div>

  <Or />
  <div class="text-center">
    <button
      on:click={login}
      class="btn btn-lg btn-secondary btn-block"
      type="button">
      Sign in
    </button>
  </div>
</form>
